<template>
    <div class="af-jobview-action-btns afu-flex afu-gap-3 afu-items-center">
        <SaveJobMobile
            :job-uuid="$_job.uuid" 
        />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import SaveJobMobile from './Actions/SaveJobMobile';
    // import PrintJob from './Actions/PrintJob';

    export default {
        name: 'JobViewActionsMobile',

        components: {
            // PrintJob,
            SaveJobMobile,
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),
        },
    };
</script>
